import { render } from "./PasteFormat.vue?vue&type=template&id=035d7538"
import script from "./PasteFormat.vue?vue&type=script&lang=js"
export * from "./PasteFormat.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__